export default __webpack_public_path__ + "static/media/b2b.8ce1666b.svg";